import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { vRole } from './directives/role'
import { useAuthStore } from './stores/auth'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// Initialize auth store
const authStore = useAuthStore()
authStore.initialize()

// Add navigation guard for role-based route protection
router.beforeEach((to, from, next) => {
  const requiredRole = to.meta.requiredRole

  if (requiredRole) {
    if (!authStore.hasRole(requiredRole)) {
      // Redirect to home or show error if user doesn't have required role
      next({ name: 'home' })
      return
    }
  }

  next()
})

// Configure toast
const toastOptions = {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
}

// Register plugins and mount app
app.use(router)
app.use(Toast, toastOptions)
app.directive('role', vRole)
app.mount('#app')
